import { gql } from "@apollo/client";

export const QUERY_QUOTE_PAGE = gql`
  query quotePage {
    quotePage {
      data {
        attributes {
          quoteOfTheDayTitle
          cta {
            text
            link
          }
        }
      }
    }
  }
`;

export const QUERY_CURRENT_QUOTE = gql`
  query quote($date: DateFilterInput) {
    quotes: quotes_connection(filters: { date: $date }) {
      data {
        id
        attributes {
          quote
          author
          date
          occupation
          quoteWithLinks
          links {
            podcast {
              data {
                attributes {
                  slug
                }
              }
            }
            course {
              data {
                attributes {
                  slug
                }
              }
            }
            knowledgeBase {
              data {
                attributes {
                  slug
                }
              }
            }
            redirectToCalendar
            redirectToLeadershipWheel
          }
        }
      }
    }
  }
`;
